import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/activities/', { params });
  },
  listFilters() {
    return Backend.get('/activities/filters');
  },
  searchUser(name = '') {
    return Backend.get('/activities/search-user', { params: { full_name: name } });
  },
};
